"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKMainNav = void 0;
var react_1 = __importDefault(require("react"));
var common_1 = require("../../../common");
var __1 = require("../../../");
require("./GKMainNav.css");
var GKMainNav = function (props) {
    // State and hooks
    var isMobileSized = (0, __1.useDeviceSizes)().isMobileSized;
    // The shell context, for setting our expansion state.
    var _a = react_1.default.useContext(__1.GKLayoutShellContext), isNavExpanded = _a.isNavExpanded, setNavExpanded = _a.setNavExpanded;
    // Variables and defaults
    var name = "gk-main-nav";
    var _b = (0, common_1.mapDefaultProps)(props, {
        _gkComponentName: name,
        className: [
            props.darkMode && "bg-dark",
            isNavExpanded ? "expanded" : "collapsed",
        ]
            .filter(function (c) { return c; })
            .join(" "),
    }), children = _b.children, darkMode = _b.darkMode, _c = _b.home, home = _c === void 0 ? { href: "/" } : _c, _d = _b.logo, logo = _d === void 0 ? __1.GProduct.Granular : _d, navItems = _b.navItems, secondaryItems = _b.secondaryItems, passthroughProps = __rest(_b, ["children", "darkMode", "home", "logo", "navItems", "secondaryItems"]);
    // Helper function to rework nav item's onClick event. We add our own
    // onClick to close the navbar, then call the original onClick event.
    var mapNavItem = react_1.default.useCallback(function (item) {
        if ((0, __1.isAnchorOrRouterTarget)(item)) {
            var newItem = __assign({}, item);
            var originalOnClick_1 = item.onClick;
            newItem.onClick = function (e) {
                setNavExpanded(false);
                originalOnClick_1 === null || originalOnClick_1 === void 0 ? void 0 : originalOnClick_1(e);
            };
            return newItem;
        }
        return item;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Using the useResponsive and useMemo hooks to reduce churn on nav
    // items. Mobile items need to be mapped to update the onClick but
    // look the same regardless of expanded state. Tablet+ items don't
    // need remapping, but update when the navbar expands/collapses.
    var responsiveNavItems = (0, __1.useResponsive)({
        xs: react_1.default.useMemo(function () { return (0, __1.getNavItemElements)((navItems === null || navItems === void 0 ? void 0 : navItems.map(mapNavItem)) || []); }, [mapNavItem, navItems]),
        md: react_1.default.useMemo(function () { return (0, __1.getNavItemElements)(navItems || [], !isNavExpanded); }, [isNavExpanded, navItems]),
    });
    var responsiveSecondaryItems = (0, __1.useResponsive)({
        xs: react_1.default.useMemo(function () { return (0, __1.getNavItemElements)((secondaryItems === null || secondaryItems === void 0 ? void 0 : secondaryItems.map(mapNavItem)) || []); }, [mapNavItem, secondaryItems]),
        md: react_1.default.useMemo(function () { return (0, __1.getNavItemElements)(secondaryItems || [], !isNavExpanded); }, [isNavExpanded, secondaryItems]),
    });
    // Set up the logo
    var memoLogo = react_1.default.useMemo(function () { return (react_1.default.createElement(__1.GKGranularLogo, { product: logo, variant: isMobileSized
            ? __1.GLogoVariant.Logotype
            : isNavExpanded
                ? __1.GLogoVariant.LockupHorizontal
                : __1.GLogoVariant.Default, darkMode: darkMode })); }, [logo, darkMode, isNavExpanded, isMobileSized]);
    // Create the home link
    var linkedLogo = react_1.default.useMemo(function () {
        if ((0, __1.isRouterNavTarget)(home)) {
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            var Component = require("react-router-dom").NavLink;
            return react_1.default.createElement(Component, { to: home.to || "" }, memoLogo);
        }
        else {
            return (react_1.default.createElement("a", { "data-qa": name + "--home", href: (home && home.href) || "/" }, memoLogo));
        }
    }, [home, memoLogo]);
    return (react_1.default.createElement("div", __assign({}, passthroughProps),
        react_1.default.createElement("div", { "data-qa": name + "--topbar", className: name + "--topbar" },
            react_1.default.createElement("div", { "data-qa": name + "--logo-container", className: "logo-container" }, linkedLogo),
            react_1.default.createElement("div", { "data-qa": name + "--toggle-container", className: name + "--toggle-container", onClick: function () { return setNavExpanded(!isNavExpanded); }, role: "button", "aria-pressed": isNavExpanded, tabIndex: 0, onKeyDown: function (e) { return e.key === "Enter" && setNavExpanded(!isNavExpanded); } },
                react_1.default.createElement(__1.GKIcon, { "data-qa": name + "--toggle-icon", name: isNavExpanded ? __1.GKIconName.MenuOpen : __1.GKIconName.Menu }))),
        react_1.default.createElement("div", { "data-qa": name + "--content", className: name + "--content" },
            react_1.default.createElement("div", { "data-qa": name + "--children", className: name + "--children" }, children),
            (responsiveNavItems === null || responsiveNavItems === void 0 ? void 0 : responsiveNavItems.length) ? (react_1.default.createElement(__1.GKNav, { "data-qa": name + "--items", className: name + "--items", orientation: __1.Orientation.Vertical }, responsiveNavItems)) : null,
            (responsiveSecondaryItems === null || responsiveSecondaryItems === void 0 ? void 0 : responsiveSecondaryItems.length) ? (react_1.default.createElement(__1.GKNav, { "data-qa": name + "--secondary", className: name + "--secondary", orientation: __1.Orientation.Vertical }, responsiveSecondaryItems)) : null)));
};
exports.GKMainNav = GKMainNav;
